import { useEffect } from "react";
import { Link } from "react-router-dom";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import logo150 from "assets/images/logo150.png";
import DocumentThumbnailV2 from "./DocumentThumbnailV2";
import { V2_DOCUMENTS, V2_ENROLLMENT_YEAR } from "./documentV2Config";
import "./formulariosV2.css";

export default function FormulariosV2() {
  useEffect(() => {
    window.document.title = `Formularios de inscripción ${V2_ENROLLMENT_YEAR} | V2`;
  }, []);
  return (
    <main className="formularios-v2">
      <div className="formularios-v2__content">
        <Link to="/formularios" className="formularios-v2__back">
          <ArrowBackOutlinedIcon fontSize="small" /> Ver versión anterior
        </Link>
        <header className="formularios-v2__hero">
          <img src={logo150} alt="Instituto Sagrado Corazón" width="72" height="90" />
          <p>INSTITUTO SAGRADO CORAZÓN</p>
          <h1>Inscripción {V2_ENROLLMENT_YEAR}</h1>
          <span>La documentación de siempre, más fácil de completar.</span>
          <p className="formularios-v2__intro">
            Completá un solo formulario y revisá la Solicitud y el Anexo antes de descargarlos.
          </p>
        </header>
        <section className="formularios-v2__documents" aria-label="Documentos de inscripción">
          {Object.entries(V2_DOCUMENTS).map(([type, config], index) => (
            <Link to={`/formularios/${type}-inscripcion-v2`} key={type}>
              <div className="formularios-v2__thumbnail">
                <DocumentThumbnailV2 documentType={type} />
              </div>
              <div className="formularios-v2__card-copy">
                <small>
                  <DescriptionOutlinedIcon fontSize="small" />{" "}
                  {index === 0 ? "Documento principal" : "Documento complementario"}
                </small>
                <h2>{config.heading}</h2>
                <p>
                  {index === 0
                    ? "Datos del alumno, responsables y contrato de adhesión."
                    : "Personas autorizadas para el retiro y transporte escolar."}
                </p>
                <b>
                  Completar formulario <ArrowForwardOutlinedIcon fontSize="small" />
                </b>
              </div>
            </Link>
          ))}
        </section>
      </div>
    </main>
  );
}
